import { CommonModule } from '@angular/common';
import { Component, inject, Input, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { LoadingService } from '@eng-dx-gpt/loading';
import { FileRemoveEvent, FileSelectEvent, FileUpload, FileUploadModule } from 'primeng/fileupload';
import { convertFileToBase64 } from '../../../utils';
import { FileUploadInput } from './../../../models';
import { BaseInputComponent } from './../base-input/base-input.component';

@Component({
    selector: 'lib-file-upload-input',
    standalone: true,
    imports: [CommonModule, FileUploadModule, ReactiveFormsModule],
    templateUrl: './file-upload-input.component.html',
    styleUrl: './file-upload-input.component.scss'
})
export class FileUploadInputComponent extends BaseInputComponent {
    @Input() name!: string;
    @Input() override control!: FileUploadInput;
    @ViewChild('fileUploadInput', { static: true }) private _fileUpload!: FileUpload;

    selectedFiles = new Array<File>();

    private _loader = inject(LoadingService);

    onSelect(event: FileSelectEvent) {
        this.selectedFiles = Array.from(event.files).map((f) => {
            return { ...f, ...{ name: this.control.defaultFileName || f.name } };
        });
        const file = event.currentFiles[0];
        this._loader.showLoader();
        const fileToBase64 = async () => {
            try {
                const base64 = await convertFileToBase64(file);
                this.control.setValue(base64, { onlySelf: false, emitEvent: true });
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
                this.control.setValue(null, { onlySelf: false, emitEvent: true });
            } finally {
                this.control.markAsDirty();
                this.control.updateValueAndValidity();
                this._loader.hideLoader();
            }
        };

        fileToBase64();
    }

    onRemove(event: FileRemoveEvent) {
        const spliceIdx = this.selectedFiles.findIndex(
            (f) =>
                f.name === event.file.name &&
                f.size === event.file.size &&
                f.type === event.file.type &&
                f.lastModified === event.file.lastModified
        );
        this.selectedFiles.splice(spliceIdx, 1);
        this.control.setValue(this.selectedFiles.length ? this.selectedFiles.length : null, {
            emitEvent: true
        });
        this.control.markAsDirty();
        this.control.updateValueAndValidity();
    }

    onClear() {
        this.selectedFiles = [];
        this.control.setValue(this.selectedFiles.length ? this.selectedFiles.length : null, {
            emitEvent: true
        });
        this.control.markAsDirty();
        this.control.updateValueAndValidity();
    }
}
